var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"totaluser-content"},[_c('h1',[_vm._v("統計日期："+_vm._s(_vm.dateTime))]),_c('h1',[_vm._v("用戶總數："+_vm._s(_vm.userNum))])])
}
var staticRenderFns = []

export { render, staticRenderFns }